import * as DashboardConstants from '.././DashboardConstants';

export const ExceptionClassificationTableHeaders = [
    {
        key: 'resource_name',
        header: DashboardConstants.ResourceName
    },
    {
        key: 'count',
        header: DashboardConstants.Count
    },
    {
        key: 'countPercentage',
        header: DashboardConstants.CountPercent
    }
    
];
export const LongRunningAutomataTableHeaders = [
    {
        key: 'automata_name',
        header: DashboardConstants.AutomataName
    },
    {
        key: 'count',
        header: DashboardConstants.Count
    },
    {
        key: 'countPercentage',
        header: DashboardConstants.CountPercent
    }
    
];
